export default __webpack_public_path__ + "static/media/031-warning-1.e21d6983.png";